import { useMemo, useRef } from 'react'
import { useQuery } from '@apollo/client'

import type {
  getTags,
  getTagsVariables,
} from 'Constants/graphql/queries/listing/__generated__/getTags'
import { GET_TAGS } from 'Constants/graphql/queries/listing/GetTags'

import type { Tag } from './tagging.types'

interface UseOrgTagsResult {
  orgTags: Tag[]
  orgTagsRef: { current: Tag[] }
  refetchTags: () => Promise<unknown>
}

export const useOrgTags = (orgId: string): UseOrgTagsResult => {
  const { data: tagsData, refetch: refetchTags } = useQuery<
    getTags,
    getTagsVariables
  >(GET_TAGS, {
    skip: !orgId,
    variables: { organisationID: orgId },
  })

  const orgTags: Tag[] = useMemo(
    () =>
      (tagsData?.tags ?? []).map(t => ({
        color: t.color,
        id: t.id,
        name: t.name,
      })),
    [tagsData],
  )

  const orgTagsRef = useRef<Tag[]>(orgTags)

  orgTagsRef.current = orgTags

  return { orgTags, orgTagsRef, refetchTags }
}
